var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconButton',{staticClass:"icon-button-shuffle",class:{ 'is-rotating': _vm.isRotating },attrs:{"icon":"ArrowsRotateSolidIcon","small":"true"},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }